module.exports = __webpack_public_path__ + "static/wix_visa-mastercard-94ccc0fd9f7ff2fd5b183b6e482c2c95.svg";